import { Box, Center } from "@chakra-ui/react";
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import ProductCard from "../products/productCard";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default function Index({ products, cartProductIds }) {
  return (
    <Box maxWidth="100%" mt="43px" justifyContent="center">
      <Swiper
        breakpoints={{
          // when window width is >= 640px
          2000: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 90,
          },
          1355: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          600: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
        }}
        spaceBetween={120}
      >
        {products &&
          products.map((product) => (
            <SwiperSlide key={product?.id} style={{ maxWidth: "1170px" }}>
              <Center width="100%">
                <ProductCard
                  product={product}
                  cartProductIds={cartProductIds}
                />
              </Center>
            </SwiperSlide>
          ))}
      </Swiper>
    </Box>
  );
}
